module.exports = "<p>\n  button-form-validate works!\n</p>\n"